<mg-file-list-container
  [files]="mingaFiles"
  (fileDelete)="onFileDelete($event)"
  [listStyle]="fileListStyle"
  [enableFileManagement]="'MINGA_FILE_CREATE' | hasPermission">
</mg-file-list-container>
